"use strict"

import { getLoggedIn, getCartCount } from '../utils/cookies';

function applyUserStatus() {
    const loggedIn = getLoggedIn();
    document.body.classList.toggle('user-logged-in', loggedIn);
    document.body.classList.toggle('user-logged-out', !loggedIn);

    const cartCount = getCartCount();
    document.querySelectorAll('.js-cart-count').forEach(el => {
        if (cartCount > 0) {
            el.textContent = cartCount;
            el.classList.add('is-visible');
        } else {
            el.classList.remove('is-visible');
        }
    });

    document.querySelectorAll('.js-append-returnurl').forEach(el => {
        if (!el.dataset.href) return;
        const separator = el.dataset.href.indexOf('?') === -1 ? '?' : '&';
        el.setAttribute('href', `${el.dataset.href}${separator}returnurl=${encodeURIComponent(document.location.href)}`);
    });
}

export function init() {
    applyUserStatus();

    // Cookies from the AJAX handshake arrive ~200ms after page load. We can't poll
    // cookies directly, but the same AJAX response typically mutates the DOM too.
    const deadline = Date.now() + 5000;

    const observer = new MutationObserver((_, obs) => {
        const cookiesArrived = getLoggedIn() || getCartCount() > 0;

        if (cookiesArrived || Date.now() > deadline) {
            // Disconnect before mutating the DOM to prevent our own writes
            // from triggering another callback.
            obs.disconnect();
            if (cookiesArrived) {
                applyUserStatus();
            }
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });
}
